/**
 * bundles_array = [
 {
      bundle_name: 'Face Bottle Bundle',
      bundle_class: 'Face_Bottle_Bundle',
      bundle_percentage: 50,
      bundle_components: [39289611223155,6553685622899],
      free_components: [
            bundle_percentage: 100,
            free_bundle_componets: [1,2,3,4,5,5,6,7]
      ]
    },
 {
      bundle_name: 'Face Bottle Oil Mini1 Bundle',
      bundle_class: 'Face_Bottle_Oil_Mini1_Bundle',
      bundle_percentage: 75,
      bundle_components: [39289611223155,6553685622899,39289616302195,39289611124851]
    },
 */
import {Emitter} from './emitter';
import * as bundleHelper from './helpers/bundle';

const classSelector = '.btn-buynow-bundle';
const attributeSelector = 'data-bundle';
const soldOutClass = 'btn-buynow-bundle-sold-out';
const us_only_product_variants = ABV4_SETTINGS.only_us_product_variants;
const us_and_ca_only_product_variants = ABV4_SETTINGS.us_and_ca_product_variants;
export class Bundle extends Emitter {
    constructor(api, popup, button, mode = null) {
        super();
        this.api = api;
        this.popup = popup;
        this.bundleData = null;
        this.mode = mode;
        this.bundleHandle = $(button).data('bundle');
        this.bundleLabel = $(button).data('discount-label');
        this.skiptocart = false;
        this.frequency = null;
        this.bundleNotAvailableInCountry = false;
        this.ctalabel = typeof $(button).data('ctalabel') !== 'undefined' ? $(button).data('ctalabel') : false;
        this.descriptionClone = $(button).find('.bundle_popup_description_clone').clone().html();
        this.subscriptionProduct = typeof $(button).data('subscription-product') !== 'undefined' ? $(button).data('subscription-product') : false;
        this.openPopup = typeof $(button).data('open-popup') !== 'undefined' ? $(button).data('open-popup') : false;
        this.bundle = this.getBundle(this.bundleHandle);
        this.sold = this.available(this.bundle);
        this.gallery = null;
        this.handleClick = this.handleClick.bind(this);
        this.bundleToCart = this.bundleToCart.bind(this);
        this.soldOut = this.soldOut.bind(this);
        this.transformProductToSubProduct = this.transformProductToSubProduct.bind(this);
        if(this.bundleNotAvailableInCountry) {
            this.notAvailableInYourCountry(button);
            return;
        }
        if (this.sold) {
            this.soldOut(button);
            return;
        }
        if(this.getCookie('localization') != 'US' && this.sold == false && this.bundleNotAvailableInCountry == false) {
            this.setBundleCollectionPrice(this.bundle, button);
        }
        $(button).on('click', this.handleClick);

    }

    setBundleCollectionPrice(bundle, button) {
        const tile = $(button).closest('.pc-bundle-tile--js'),
        prices = bundleHelper.getBundlePrice(bundle);
        let discountedPrice = prices[0],
        msrp = prices[1];
        if(discountedPrice == msrp || this.getCookie('localization') != "US") {
            tile.find('.comparison-price--js').addClass('d-none');  
            tile.find('.discount').addClass('d-none');
        } else {
            tile.find('.discount').removeClass('d-none');
            tile.find('.comparison-price--js').removeClass('d-none');  
        }
        if(this.getCookie('localization') != "US") {
            discountedPrice = prices[1];
        }
        tile.find('.comparison-price--js').text(msrp);
        tile.find('.current-price--js').text(discountedPrice);

    }


    
    handleClick(e) {
        
        e.preventDefault();
        const { bundle, bundleHandle, popup, mode, openPopup, subscriptionProduct } = this;
        if (popup !== null) {
            popup.container.find('.v5-bundle-upsell-popup-heading').text(' ');
            popup.container.find('.v5-bundle-upsell-placeholder-collection').html(' ');
            popup.container.find('.v5-upsell-popup-heading').text(' ');
            popup.container.find('.cart-bundle-wrapper').remove();
        }
        const item = {
            BundleName: bundle.bundle_name,
            BundleClass: bundle.bundle_class
        };
        const skiptocart = $(e.currentTarget).data('skiptocart');
        if(typeof skiptocart != 'undefined' && skiptocart == true) {
            this.skiptocart = true;
        }

        if(typeof $(e.currentTarget).data('gallery') != 'undefined') {
            this.gallery = $(e.currentTarget).data('gallery');
        }
        if(typeof $(e.currentTarget).data('frequency') != 'undefined'){
            this.frequency = $(e.currentTarget).data('frequency');
        }

        if (popup === null) {
            $(e.currentTarget).attr('disabled', 'true');
            this.bundleData = this.prepareBundleData(bundle);
            this.api.addToCart(this.bundleData.data).then(() => {
                
        
                _learnq.push(['track', 'Added to Cart', item]);
                setTimeout(() => {
                    window.location = window.location.origin + "/cart"
                }, 1500);
            }).catch((error) => {
                console.log(error);
            });

            return;

        } else if (!openPopup) {
            this.bundleData = this.prepareBundleData(bundle);
            this.popup.handleFormSubmitting();
        
            this.api.addToCart(this.bundleData.data).then(() => {
                _learnq.push(['track', 'Added to Cart', item]);
                if (this.mode === 'upsell') {
                    this.emit('bundleDelete', this.bundleData);
                } else if (this.mode !== 'upsell') {
                    this.popup.handleBundleSubmitted(this.bundleData, mode, this.skiptocart);
                } else {

                }
            }).catch((error) => {
                this.popup.handleFormSubmitFailed();
            });

            return;
        }
        const atc = popup.container.find('.add-bundle-to-cart');
        atc.unbind('click');


        popup.container.find('.bundle-pane').removeClass('d-none');
        popup.container.find('.product-pane').addClass('d-none');
        popup.container.find('.v4-add-to-cart-popup').attr('data-popup-product-handle', bundleHandle);
        popup.setBundleHandle(bundleHandle, bundle, this.bundleLabel, subscriptionProduct, this.descriptionClone, skiptocart, this.ctalabel,this.gallery, this.frequency);

        atc.on("click", this.bundleToCart);

    }

    bundleToCart(e) {
        const {bundle, mode} = this, bundleData = this.prepareBundleData(bundle),
            subscriptionProducts = this.popup.subscriptionProducts();
        if(subscriptionProducts.length > 0 && subscriptionProducts[0].subscribed === 'true') {
            if(subscriptionProducts[0].frequency.length === 0) {
                $('.bundle-pane .subscription-frequency').find('.frequency').focus();
                return;
            }
        }

        this.popup.handleFormSubmitting();
        const item = {
            BundleName: bundle.bundle_name,
            BundleClass: bundle.bundle_class
        };

        _learnq.push(['track', 'Added to Cart', item]);

        this.transformProductToSubProduct(bundleData.data, subscriptionProducts).then((response) => {
            const bundle = response;
            this.api.addToCart(bundle).then(() => {
                this.popup.handleBundleSubmitted(bundleData, null, this.skiptocart);
            }).catch((error) => {
                console.log(error);
                this.popup.handleFormSubmitFailed();
            });
        });
    }

    getBundle(bundleClass) {
        for (const bundle of bundles_array) {
            if (bundle.bundle_class === bundleClass) {
                this.bundle = bundle;
                break;
            }
        }

        return this.bundle;
    }

    available(bundle) {
        if (!bundle) {
            return true;
        } 

        // if(this.getCookie('localization') != 'US') {
        //     this.bundle.bundle_discount = 0;
        // }
        bundle.bundle_components.forEach((variant) => {
            if (typeof available_bundle_variants[variant.id] == 'undefined') {
                if ('replace_variant' in variant) {
                    if (typeof available_bundle_variants[variant.replace_variant] == 'undefined') {
                        bundle['sold'] = true;
                    } else {
                        variant.id = variant.replace_variant;
                        variant.price = variant.replace_price;
                    }
                } else {
                    bundle['sold'] = true;
                    if(sold_out_bundle_variants.indexOf(variant.id) === -1) {
                        this.bundleNotAvailableInCountry = true;
                    }
                }


            }
        });

        if (bundle.hasOwnProperty('free_components')) {

            bundle.free_components.free_bundle_componets.forEach((product) => {
                if (typeof available_bundle_variants[product.id] == 'undefined') {
                    if ('replace_variant' in product) {
                        if (typeof available_bundle_variants[product.replace_variant] == 'undefined') {
                            bundle['sold'] = true;
                        } else {
                            product.id = product.replace_variant;
                            product.price = product.replace_price;
                        }
                    } else {
                        bundle['sold'] = true;
                        if(sold_out_bundle_variants.indexOf(product.id) === -1) {
                            this.bundleNotAvailableInCountry = true;
                        }
     
                    }


                    
                }
            });
        }

        return bundle['sold'];
    }

    prepareBundleData(bundle) {
        let bundleData = {
            bundle_name: bundle.bundle_name,
            bundle_class: bundle.bundle_class,
            bundle_sold: bundle.sold,
            data: {
                items: [],
            },
        }

        let bundleOrgPrice = '';
        if (bundle.hasOwnProperty('bundle_original_price')) {
            bundleOrgPrice = bundle.bundle_original_price;
        }

        const countBundle = this.countProductsInBundle(bundle);
        if (bundle.hasOwnProperty('free_components')) {
            bundle.free_components.free_bundle_componets.forEach((variant) => {
                const qty = this.getQty(variant);
                    // get percetange for free product, price must be 0.01 $
                let freeComponentDiscount = this.getFreeComponentDiscount(variant.price);
                    // if(this.getCookie('localization') != 'US'){
                    //     freeComponentDiscount = 0;
                    // }
                bundleData.data.items.push({
                    id: variant.id,
                    quantity: qty,
                    properties: {
                        "_bundle": bundle.bundle_name,
                        "_bundle_discount": freeComponentDiscount,
                        "_bundle_class": bundle.bundle_class,
                        // "_product_price": variant.price,
                        "_base_product_qty": qty,
                        "_single_product": countBundle,
                        "_free_bundle_component": true
                    }
                });
            });
        }

        bundle.bundle_components.forEach((variant) => {
            const qty = this.getQty(variant);
            let bundleDiscount = bundle.bundle_discount;
            if(variant.hasOwnProperty('discount')) {
                bundleDiscount = variant.discount;
            }
            // if(this.getCookie('localization') != 'US'){
            //     bundleDiscount = 0;
            // }

            bundleData.data.items.push({
                id: variant.id,
                quantity: qty,
                properties: {
                    "_bundle": bundle.bundle_name,
                    "_bundle_discount": bundleDiscount,
                    "_bundle_class": bundle.bundle_class,
                    // "_product_price": variant.price,
                    "_base_product_qty": qty,
                    "_single_product": countBundle,
                }
            });
        });

        return bundleData;

    }

    // get percetange for free product, price must be 0.01 $
    getFreeComponentDiscount(price) {
        const calculateDiscount = 1 / price;
        const result = 100 - calculateDiscount;

        return result;
    }
    notAvailableInYourCountry(button) {
        console.log();
        $(button).addClass(soldOutClass);
        $(button).html("Unavailable");
        $(button).removeAttr('href');
        $(button).css("cursor", "no-drop");
        const parrentElement = $(button).closest('.check-localization-availability');
        if(Boolean(parrentElement)) {
            parrentElement.addClass('unavailable');
        }
    }



    soldOut(button) {
        $(button).addClass(soldOutClass);
        $(button).html("SOLD OUT");
        $(button).removeAttr('href');
        $(button).css("cursor", "no-drop");
        const parrentElement = $(button).closest('.check-bundle-availability');
        if(Boolean(parrentElement)) {
            parrentElement.addClass('sold-out');
        }
    }

    getQty(variant) {
        let qty;
        if (variant.hasOwnProperty('qty')) {
            qty = variant.qty;
        } else {
            qty = 1;
        }

        return qty;
    }

    async transformProductToSubProduct(atcData, subData) {
        let result = [];
        for (const item of subData) {
            if (item.subscribed === 'true') {
                for (const atcItem of atcData.items) {
                    if (atcItem.id === item.variant_id) {
                        await this.api.productByHandle(item.handle)
                            .then((res) => {
                                const sellingPlanGroups = res.ajax.selling_plan_groups;
                                if (sellingPlanGroups.length > 0) {
                                    const sellingPlans = sellingPlanGroups[0].selling_plans;
                                    for (const sellingPlan of sellingPlans) {
                                        if (sellingPlan.name === item.frequency) {
                                            atcItem.selling_plan = sellingPlan.id;
                                            atcItem.quantity = item.quantity;
                                            atcItem.properties._base_product_qty = item.quantity;
                                            break;
                                        }
                                    }
                                }
                            });
                    }
                }
            }
        }

        return Promise.resolve(atcData);
    }

    countProductsInBundle(bundle) {
        let count = 0;
        if (bundle.bundle_components) {
            count += bundle.bundle_components.length;
        }

        if (bundle.free_components) {
            count += bundle.free_components.free_bundle_componets.length;
        }

        if ("not_single_product" in bundle && bundle.not_single_product) {
            return false;
        }

        if (count === 1) {
            return true;
        } else {
            return false;
        }
    }

    getCookie(name) {
        var pattern = RegExp(name + "=.[^;]*")
        var matched = document.cookie.match(pattern)
        if(matched){
            var cookie = matched[0].split('=')
            return cookie[1]
        }
        return null;
    }
}